module.exports = __webpack_public_path__ + "static/connectionskeynote-fea8fc4cd12a80e2d31724be1491684f.jpeg";